import { render, staticRenderFns } from "./updateMemberInfo.vue?vue&type=template&id=5b2d572e&scoped=true"
import script from "./updateMemberInfo.vue?vue&type=script&lang=js"
export * from "./updateMemberInfo.vue?vue&type=script&lang=js"
import style0 from "./updateMemberInfo.vue?vue&type=style&index=0&id=5b2d572e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2d572e",
  null
  
)

export default component.exports